export function OutlinePautaTradicionalIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0623 5.99999L13.648 3.5856C13.4704 3.408 13.2592 3.264 13.0336 3.168C12.784 3.0576 12.5152 3 12.2368 3H6.00159C4.8928 3 4 3.8976 4 5.00159V19.0031C4 19.7567 4.4176 20.4095 5.032 20.7503"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0303 18L18.0639 19.0032C18.0639 20.1072 17.1711 21 16.0623 21H15.0303"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7357 13.2226L13.0813 18.877L10.2542 16.0498L15.9085 10.3906L18.0637 12.5506L18.7357 13.2226Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4463 12.5127L18.7359 13.2231L18.0639 12.5511L15.9087 10.3911L16.6191 9.68554C17.0175 9.28714 17.5407 9.09034 18.0639 9.09994C18.5631 9.10954 19.0623 9.30634 19.4415 9.68554H19.4463C20.2287 10.4679 20.2287 11.7303 19.4463 12.5127Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0816 18.878L11.6656 20.294L8.13281 20.9996L8.83841 17.4668L10.2544 16.0508L13.0816 18.878Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
